import KOLProvider from "../resource/kol";

const KOLService = new KOLProvider();

const state = {
    staff: [],
    creators: [],
    creatorsPagination: { total: 0, page: 1, per_page: 50 },
    assignments: [],
    assignmentsPagination: { total: 0, page: 1, per_page: 50 },
    reportByStaff: []
};

const getters = {
    getStaff: state => state.staff,
    getCreators: state => state.creators,
    getCreatorsPagination: state => state.creatorsPagination,
    getAssignments: state => state.assignments,
    getAssignmentsPagination: state => state.assignmentsPagination,
    getReportByStaff: state => state.reportByStaff
};

const mutations = {
    SET_STAFF(state, data) {
        state.staff = data;
    },
    SET_CREATORS(state, data) {
        state.creators = data.items || [];
        state.creatorsPagination = {
            total: data.total || 0,
            page: data.page || 1,
            per_page: data.per_page || 50
        };
    },
    SET_ASSIGNMENTS(state, data) {
        state.assignments = data.items || [];
        state.assignmentsPagination = {
            total: data.total || 0,
            page: data.page || 1,
            per_page: data.per_page || 50
        };
    },
    SET_REPORT_BY_STAFF(state, data) {
        state.reportByStaff = data;
    }
};

const actions = {
    // Staff
    async listStaff({ commit }, params) {
        try {
            const response = await KOLService.StaffList(params);
            commit("SET_STAFF", response.data.Data || []);
            return response;
        } catch (error) {
            commit("SET_STAFF", []);
            throw error;
        }
    },
    createStaff({ commit }, params) {
        return KOLService.StaffCreate(params);
    },
    updateStaff({ commit }, { id, payload }) {
        return KOLService.StaffUpdate(id, payload);
    },
    deleteStaff({ commit }, id) {
        return KOLService.StaffDelete(id);
    },

    // Creators
    async listCreators({ commit }, params) {
        try {
            const response = await KOLService.CreatorList(params);
            const data = response.data.Data && response.data.Data[0] ? response.data.Data[0] : { items: [], total: 0 };
            commit("SET_CREATORS", data);
            return response;
        } catch (error) {
            commit("SET_CREATORS", { items: [], total: 0 });
            throw error;
        }
    },
    createCreator({ commit }, params) {
        return KOLService.CreatorCreate(params);
    },
    updateCreator({ commit }, { id, payload }) {
        return KOLService.CreatorUpdate(id, payload);
    },
    deleteCreator({ commit }, id) {
        return KOLService.CreatorDelete(id);
    },

    // Assignments
    async listAssignments({ commit }, params) {
        try {
            const response = await KOLService.AssignmentList(params);
            const data = response.data.Data && response.data.Data[0] ? response.data.Data[0] : { items: [], total: 0 };
            commit("SET_ASSIGNMENTS", data);
            return response;
        } catch (error) {
            commit("SET_ASSIGNMENTS", { items: [], total: 0 });
            throw error;
        }
    },
    createAssignment({ commit }, params) {
        return KOLService.AssignmentCreate(params);
    },
    updateAssignment({ commit }, { id, payload }) {
        return KOLService.AssignmentUpdate(id, payload);
    },
    deleteAssignment({ commit }, id) {
        return KOLService.AssignmentDelete(id);
    },
    updateAssignmentStatus({ commit }, { id, payload }) {
        return KOLService.AssignmentUpdateStatus(id, payload);
    },
    updateAssignmentPayment({ commit }, { id, payload }) {
        return KOLService.AssignmentUpdatePayment(id, payload);
    },
    getAssignmentTimeline({ commit }, id) {
        return KOLService.AssignmentTimeline(id);
    },
    getAssignmentOrderItems({ commit }, orderNumber) {
        return KOLService.AssignmentOrderItems(orderNumber);
    },

    // Reports
    async fetchReportByStaff({ commit }, params) {
        try {
            const response = await KOLService.ReportByStaff(params);
            commit("SET_REPORT_BY_STAFF", response.data.Data || []);
            return response;
        } catch (error) {
            commit("SET_REPORT_BY_STAFF", []);
            throw error;
        }
    }
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};
